import { clock } from '@/services/clock';
import { triggerBlobDownload } from '@/shared/lib/download/triggerBlobDownload';

export type FileType = 'csv' | 'json' | 'python' | 'txt';

export const formatDateForFilename = (date: Date): string => {
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${date.getFullYear().toString().slice(-2)}${pad(date.getMonth() + 1)}${pad(date.getDate())}_${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}`;
};

export const getMimeType = (fileType: FileType): string => {
  const types: Record<FileType, string> = {
    csv: 'text/csv;charset=utf-8;',
    txt: 'text/txt;charset=utf-8;',
    json: 'application/json;charset=utf-8;',
    python: 'text/plain;charset=utf-8;'
  };
  return types[fileType];
};

export const downloadAsFile = (fileContent: string, fileType: FileType): void => {
  const timestamp = formatDateForFilename(clock.date());
  const mimeType = getMimeType(fileType);
  const extension = fileType === 'python' ? 'py' : fileType;

  const blob = new Blob([fileContent], { type: mimeType });
  triggerBlobDownload(blob, `GX-Data_${timestamp}.${extension}`);
};
